import { useMutation, useQuery } from "@tanstack/react-query";
import {
  generateProformaPdf,
  generateQuotationPdf,
  getAuthSession,
  getCatalog,
  getLatestPrice,
  getPricelistGrids,
  getWorkspace,
  listWorkspaces,
  login,
  logout,
  saveWorkspace,
  type LatestPriceInput,
  type SaveWorkspaceInput
} from "./client";
import type { DocumentType, QuotationRequest } from "../domain/quotation";

export function useAuthSessionQuery() {
  return useQuery({
    queryKey: ["web", "auth", "session"],
    queryFn: getAuthSession
  });
}

export function useLoginMutation() {
  return useMutation({
    mutationFn: (password: string) => login(password)
  });
}

export function useLogoutMutation() {
  return useMutation({
    mutationFn: logout
  });
}

export function useCatalogQuery(enabled = true) {
  return useQuery({
    queryKey: ["web", "catalog"],
    queryFn: getCatalog,
    enabled
  });
}

export function usePricelistGridsQuery(enabled = true) {
  return useQuery({
    queryKey: ["web", "catalog", "grids"],
    queryFn: getPricelistGrids,
    enabled
  });
}

export function useGeneratePdfMutation() {
  return useMutation({
    mutationFn: (input: { documentType: DocumentType; request: QuotationRequest }) =>
      input.documentType === "quotation"
        ? generateQuotationPdf(input.request)
        : generateProformaPdf(input.request)
  });
}

export function useLatestPriceMutation() {
  return useMutation({
    mutationFn: (input: LatestPriceInput) => getLatestPrice(input)
  });
}

export function useWorkspacesQuery(enabled = true) {
  return useQuery({
    queryKey: ["web", "workspaces"],
    queryFn: listWorkspaces,
    enabled
  });
}

export function useWorkspaceQuery(id: string | undefined, enabled = true) {
  return useQuery({
    queryKey: ["web", "workspaces", id],
    queryFn: () => getWorkspace(id ?? ""),
    enabled: enabled && Boolean(id)
  });
}

export function useSaveWorkspaceMutation() {
  return useMutation({
    mutationFn: (input: SaveWorkspaceInput) => saveWorkspace(input)
  });
}
